export const GET_USER_WALLET_REQUEST = 'GET_USER_WALLET_REQUEST';
export const GET_USER_WALLET_SUCCESS = 'GET_USER_WALLET_SUCCESS';
export const GET_USER_WALLET_FAILD = 'GET_USER_WALLET_FAILD';
